module.exports = __webpack_public_path__ + "img/paypal.fd7fff0b.png";